import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import getEmbeddedVideo from '../getEmbeddedVideo';
var imageTypes = ['.eps', '.ai', '.bmp', '.emf', '.gif', '.heic', '.jpg', '.jpeg', '.odg', '.pcx', '.png', '.psd', '.svg', '.tga', '.tiff', '.wbmp', '.webp', '.wmf'];
var audioTypes = ['.3ga', '.aac', '.ac3', '.flac', '.m4a', '.m4r', '.mp3', '.ogg', '.ra', '.ram', '.wav', '.wma'];
var videoTypes = ['.3g2', '.3gp', '.3gpp', '.asf', '.avi', '.flv', '.gvi', '.m4v', '.mkv', '.mod', '.mov', '.mp4', '.mpg', '.mts', '.rm', '.rmvb', '.ts', '.vob', '.webm', '.wmv'];
var pptTypes = ['.odp', '.pps', '.ppsx', '.ppt', '.pptx'];
var wordTypes = ['.doc', '.docx', '.wps'];
var xlTypes = ['.ods', '.wks', '.xlr', '.xls', '.xlsx', '.xps'];
var txtTypes = ['.rtf', '.txt', '.odt', '.wpd'];
function check(operand, criteria) {
  var checkExtension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return criteria.some(function (criterion) {
    return checkExtension ? operand === null || operand === void 0 ? void 0 : operand.endsWith(criterion) : operand === null || operand === void 0 ? void 0 : operand.includes(criterion);
  });
}
function getAssetType(file) {
  var bypassCustomType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var type = file.type,
    name = file.name,
    webUrl = file.webUrl;
  var fileName = name === null || name === void 0 ? void 0 : name.toLowerCase();
  var fileFormat = 'asset';
  var customType = null;
  var res = {};
  if (check(type, ['html'])) {
    throw new Error("This link is to a web page and not a file. Please provide a link to a file or create the asset via the 'Add web link', or 'Upload Microsite' options.");
  }
  if (check(type, ['pdf'])) {
    fileFormat = 'pdf';
  } else if (check(type, ['powerpoint', 'presentation']) || check(fileName, pptTypes, true)) {
    fileFormat = 'presentation';
  } else if (check(type, ['wordprocessing', 'msword']) || check(fileName, wordTypes, true)) {
    fileFormat = 'msword';
  } else if (check(type, ['excel', 'spreadsheet']) || check(fileName, xlTypes, true)) {
    fileFormat = 'spreadsheet';
  } else if (check(type, ['wma', 'audio', 'mp3']) || check(fileName, audioTypes, true)) {
    fileFormat = 'audio';
  } else if (check(type, ['video', 'mp4']) || check(fileName, videoTypes, true)) {
    fileFormat = 'video';
  } else if (check(type, ['image', 'png']) || check(fileName, imageTypes, true)) {
    fileFormat = 'image';
  } else if (check(type, ['text']) || check(fileName, txtTypes, true)) {
    fileFormat = 'text';
  }
  // Add NULL types here.
  else if (check(type, ['web', 'event'])) {
    fileFormat = null;
    if (getEmbeddedVideo(name) || getEmbeddedVideo(webUrl)) {
      customType = 'video';
    }
    if (type === 'event') {
      customType = 'event';
    }
  } else {
    fileFormat = 'asset';
  }
  if (!bypassCustomType) {
    customType = customType || fileFormat || (type === 'web' ? 'web' : 'asset');
  }
  if (fileFormat) res.fileFormat = fileFormat;
  if (customType) res.customType = customType;
  return res;
}
export default getAssetType;